import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-flask-line',
    title: '配方研發',
    desc: '經專業研發團隊，根據客戶需求量身打造獨特配方',
    tag: '研發服務',
    color: '#4CAF50',
  },
  {
    icon: 'ri-capsule-line',
    title: '劑型設計',
    desc: '依照產品原料性質、產品需求，選擇最適合的劑型，保障產品的高保存率',
    tag: '製造服務',
    color: '#66BB6A',
  },
  {
    icon: 'ri-award-line',
    title: '包裝設計',
    desc: '協助客製設計產品外包裝，為產品打造獨一無二的風格',
    tag: '設計服務',
    color: '#81C784',
  },
  {
    icon: 'ri-truck-line',
    title: '檢驗認證',
    desc: '協助產品送審第三方檢驗單位，保障產品的安全性',
    tag: '其他服務',
    color: '#A5D6A7',
  },
];

export default function ServiceCardsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Section header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 tracking-wide border border-green-200">
            我們的服務
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            專業代工服務項目
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技提供完整的保健食品與生技產品代工服務，協助品牌快速將產品推向市場
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white border border-gray-100 rounded-2xl p-7 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 cursor-default group"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${s.color}20` }}
              >
                <i className={`${s.icon} text-2xl`} style={{ color: s.color }} />
              </div>
              <span
                className="inline-block text-[0.75rem] font-medium px-3 py-1 rounded-full mb-3"
                style={{ backgroundColor: `${s.color}18`, color: s.color }}
              >
                {s.tag}
              </span>
              <h3 className="text-[#1a2e1a] font-bold text-[1.1875rem] mb-3">{s.title}</h3>
              <p className="text-gray-500 text-[0.9375rem] leading-[1.75]">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/services"
            className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1rem] px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
          >
            查看所有服務
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
